export default {
  title: {
    en: 'Something went wrong',
  },
}
